
import { defineComponent } from 'vue';

export default defineComponent({
  name: "CurrencyInput",
  computed: {
    value: {
      get(): string | number | undefined {
        return this.modelValue;
      },
      set(value: string | number): void {
        this.$emit('update:modelValue', value);
      }
    },
    inputClass(): string {
      if (!this.valid) {
        return 'currency-input__control--invalid';
      }
      if (this.changed) {
        return 'currency-input__control--changed';
      }
      return '';
    }
  },
  props: {
    modelValue: {
      type: [String, Number]
    },
    currencySymbol: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    changed: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: true
    }
  }
});
